exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a:hover {\n  color: black; }\n\na {\n  color: grey; }\n\n.dropdown-item {\n  text-align: left;\n  border-bottom: 2px solid #e4e6eb; }\n\n.avatar .avatar-status {\n  position: absolute;\n  right: 100px;\n  bottom: 0;\n  display: block;\n  width: 10px;\n  height: 10px;\n  border: -4px solid #fff;\n  border-radius: 50em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/notifications/notifications.component.scss
// module id = 506
// module chunks = 5